var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResilienc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 40,
    viewBox: "0 0 201 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_766)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_89_766)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50795 38.2854V12.7615L0 21.2695V38.2854H8.50795Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0342 25.5239L34.0342 38.2858L21.2723 38.2858L21.2723 25.5239L34.0342 25.5239Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2686 25.5242V38.286L34.0304 25.5242H21.2686Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2712 12.7618V25.5238L34.0331 12.7618V-6.10352e-05H21.2712L8.50928 12.7618H21.2712Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.668 5.24977V0.024292H200.464V4.3185C195.861 13.7865 195.55 25.7378 195.55 38.31H189.186C189.186 25.7378 191.204 12.7517 194.67 5.24977H185.668Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.542 38.31H177.385V0.024292H183.542V38.31Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.86 5.47981H104.919V0.0223999H110.86V5.47981ZM110.86 38.3098H104.919V7.56426H110.86V38.3098Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.34 38.3095H97.3994V-6.10352e-05H103.34V38.3095Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.821 5.47977H89.8799V0.0223999H95.821V5.47977ZM95.821 38.3098H89.8799V7.56422H95.821V38.3098Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9657 25.594L78.2559 23.4054C76.2236 21.6857 74.9729 19.966 74.9729 17.2563V14.3902C74.9729 9.70019 77.6827 7.14673 82.06 7.14673C86.4374 7.14673 88.7302 9.80443 88.7302 14.0254V19.1323H83.3627V13.9212C83.3627 12.41 83.0501 11.3157 82.06 11.3157C81.0699 11.3157 80.8094 12.41 80.8094 13.9212V16.4225C80.8094 18.038 81.6431 18.7675 82.9459 20.0182L85.6557 22.3632C87.6359 23.9787 88.8866 25.7504 88.8866 28.6687V31.639C88.8866 36.329 86.1247 38.726 81.6952 38.726C77.2657 38.726 74.8687 36.0684 74.8687 31.8474V26.48H80.2882V32.0037C80.2882 33.515 80.7051 34.5572 81.6952 34.5572C82.6854 34.5572 82.998 33.515 82.998 32.0037V29.0855C82.998 27.7307 82.3727 26.8447 80.9657 25.594Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.348 13.348V38.3092H128.407V7.56361H134.348V11.8367C134.817 8.97061 136.328 7.14673 138.933 7.14673C141.696 7.14673 143.103 9.43961 143.103 12.1494V38.3092H137.162V13.348C137.162 12.2015 136.745 11.3677 135.807 11.3677C134.921 11.3677 134.348 12.2015 134.348 13.348Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.621 13.9212V31.3263C150.621 33.098 150.721 34.1403 151.872 34.1403C153.022 34.1403 153.166 33.3232 153.166 30.8052V26.3262H159.115V31.3784C159.115 36.1205 156.249 38.726 151.923 38.726C147.286 38.726 144.576 36.0684 144.576 31.3263V14.5987C144.576 9.8565 147.442 7.14673 151.872 7.14673C156.353 7.14673 159.115 9.80443 159.115 14.5987V19.7055H153.123V13.9212C153.123 12.41 152.914 11.3157 151.872 11.3157C150.881 11.3157 150.621 12.41 150.621 13.9212Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.519 31.3784V26.3237H168.578V31.3263C168.578 32.9859 168.455 34.1403 167.275 34.1403C166.095 34.1403 166.024 33.046 166.024 31.3263V23.7702H171.372L174.519 20.6234V14.5987C174.519 9.80443 171.757 7.14673 167.275 7.14673C162.846 7.14673 159.98 9.8565 159.98 14.5987V31.3263C159.98 36.0684 162.927 38.726 167.513 38.726C171.838 38.726 174.519 35.2932 174.519 31.3784ZM166.024 19.914V13.9212C166.024 12.41 166.285 11.3157 167.275 11.3157C168.318 11.3157 168.578 12.41 168.578 13.9212V19.914H166.024Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.872 31.3784V26.3237H120.931V31.3263C120.931 32.9859 120.808 34.1403 119.629 34.1403C118.449 34.1403 118.378 33.046 118.378 31.3263V23.7702H123.724L126.872 20.6233V14.5987C126.872 9.80443 124.11 7.14673 119.629 7.14673C115.199 7.14673 112.333 9.8565 112.333 14.5987V31.3263C112.333 36.0684 115.281 38.726 119.866 38.726C124.192 38.726 126.872 35.2932 126.872 31.3784ZM118.378 19.914V13.9212C118.378 12.41 118.638 11.3157 119.629 11.3157C120.67 11.3157 120.931 12.41 120.931 13.9212V19.914H118.378Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8046 31.3784V26.3237H67.8639V31.3263C67.8639 32.9859 67.7408 34.1403 66.5612 34.1403C65.3815 34.1403 65.3105 33.046 65.3105 31.3263V23.7702H70.658L73.8046 20.6236V14.5987C73.8046 9.80443 71.0427 7.14673 66.5612 7.14673C62.1317 7.14673 59.2656 9.8565 59.2656 14.5987V31.3263C59.2656 36.0684 62.2132 38.726 66.7989 38.726C71.1242 38.726 73.8046 35.2932 73.8046 31.3784ZM65.3105 19.914V13.9212C65.3105 12.41 65.5711 11.3157 66.5612 11.3157C67.6034 11.3157 67.8639 12.41 67.8639 13.9212V19.914H65.3105Z",
    fill: "#000609"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6073 23.9271C51.6073 22.2596 51.1905 21.3216 50.1483 21.3216H48.7933V38.3098H42.54V0.0252075H50.6693C55.6263 0.0252075 57.8086 2.3531 57.8086 7.0431V13.7654C57.8086 14.1332 57.7924 14.4892 57.7538 14.8327L53.5613 19.0252H54.9773C54.9815 19.0275 54.9857 19.0297 54.9898 19.032H57.7516V23.0781C57.7917 23.4341 57.8086 23.804 57.8086 24.1876V38.3098H51.6073V23.9271ZM51.6073 14.0259V7.0431C51.6073 5.32344 51.1905 4.38544 50.1483 4.38544H48.7933V16.6316H50.1483C51.1905 16.6316 51.6073 15.6936 51.6073 14.0259Z",
    fill: "#000609"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 39.2429,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_89_766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 39.2429,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResilienc);
export default __webpack_public_path__ + "static/media/resilienc.7b6f1acb8489b859ef7f5b6b85dca58e.svg";
export { ForwardRef as ReactComponent };